export default __webpack_public_path__ + "static/media/closed-cn.a017ba89.png";